"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _UnionChart = _interopRequireDefault(require("./components/UnionChart.vue"));
var _QuickActions = _interopRequireDefault(require("./components/QuickActions.vue"));
var _SyncQuickActions = _interopRequireDefault(require("./components/SyncQuickActions.vue"));
var _union = require("@/api/union");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'UnionDashboard',
  components: {
    UnionChart: _UnionChart.default,
    QuickActions: _QuickActions.default,
    SyncQuickActions: _SyncQuickActions.default
  },
  data: function data() {
    return {
      showSettings: false,
      showHelp: false,
      helpStep: 0,
      rankingType: 'members',
      refreshTimer: null,
      overviewData: {
        totalUnions: 0,
        totalMembers: 0,
        activeUnions: 0,
        discountUnions: 0,
        unionChange: 0,
        memberChange: 0
      },
      chartData: {},
      recentActivities: [],
      topUnions: [],
      settings: {
        autoRefresh: false,
        refreshInterval: 60,
        pageSize: 20
      }
    };
  },
  mounted: function mounted() {
    this.loadData();
    this.loadSettings();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
    }
  },
  methods: {
    loadData: function () {
      var _loadData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _union.unionStatistics)();
            case 1:
              data = _context.v;
              this.overviewData = data.overview || this.overviewData;
              this.chartData = data.charts || {};
              this.recentActivities = data.activities || [];
              this.topUnions = data.topUnions || [];
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.error('Failed to load data:', _t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function loadData() {
        return _loadData.apply(this, arguments);
      }
      return loadData;
    }(),
    refreshData: function refreshData() {
      this.$message.info('正在刷新数据...');
      this.loadData();
    },
    quickAdd: function quickAdd() {
      this.$router.push({
        name: 'union',
        query: {
          action: 'add'
        }
      });
    },
    bulkImport: function bulkImport() {
      this.$router.push({
        name: 'union',
        query: {
          action: 'import'
        }
      });
    },
    exportAll: function exportAll() {
      this.$message.info('开始导出所有数据...');
      // Implementation for export all
    },
    viewStats: function viewStats() {
      this.$message.info('查看详细统计...');
    },
    goToUnions: function goToUnions() {
      this.$router.push({
        name: 'union'
      });
    },
    goToMembers: function goToMembers() {
      this.$router.push({
        name: 'unionMember'
      });
    },
    viewAllActivities: function viewAllActivities() {
      this.$message.info('查看所有活动记录...');
    },
    updateRanking: function updateRanking() {
      // Update ranking based on selected type
      this.loadData();
    },
    getActivityIcon: function getActivityIcon(type) {
      var icons = {
        create: 'el-icon-plus',
        update: 'el-icon-edit',
        delete: 'el-icon-delete',
        import: 'el-icon-upload',
        export: 'el-icon-download'
      };
      return icons[type] || 'el-icon-info';
    },
    loadSettings: function loadSettings() {
      var saved = localStorage.getItem('union-dashboard-settings');
      if (saved) {
        this.settings = _objectSpread(_objectSpread({}, this.settings), JSON.parse(saved));
      }
      this.setupAutoRefresh();
    },
    saveSettings: function saveSettings() {
      localStorage.setItem('union-dashboard-settings', JSON.stringify(this.settings));
      this.setupAutoRefresh();
      this.showSettings = false;
      this.$message.success('设置已保存');
    },
    setupAutoRefresh: function setupAutoRefresh() {
      var _this = this;
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer);
      }
      if (this.settings.autoRefresh) {
        this.refreshTimer = setInterval(function () {
          _this.loadData();
        }, this.settings.refreshInterval * 1000);
      }
    },
    handleSyncCompleted: function handleSyncCompleted(syncType) {
      console.log('同步完成:', syncType);
      // 同步完成后刷新仪表板数据
      this.loadData();
      this.$message.success('数据同步完成，仪表板数据已更新');
    }
  }
};